var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17V3C7 1.896 7.896 1 9 1H31L39 9V37C39 38.104 38.104 39 37 39H9C7.896 39 7 38.104 7 37V31",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10H30V4",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.08 31H2.92C1.86016 31 1 30.104 1 29V19C1 17.896 1.86016 17 2.92 17H23.08C24.1398 17 25 17.896 25 19V29C25 30.104 24.1398 31 23.08 31Z",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 19.9H7.83C8.71667 19.9 9.38667 20.0567 9.84 20.37C10.2933 20.6833 10.52 21.24 10.52 22.04C10.52 22.58 10.45 23.01 10.31 23.33C10.17 23.65 9.91 23.9 9.53 24.08L10.64 28H8.79L7.9 24.37H7.39V28H5.6V19.9ZM7.89 23.34C8.25 23.34 8.5 23.2467 8.64 23.06C8.78667 22.8667 8.86 22.58 8.86 22.2C8.86 21.8333 8.79333 21.56 8.66 21.38C8.52667 21.1933 8.29667 21.1 7.97 21.1H7.39V23.34H7.89ZM13.2361 19.9H15.2761L16.7861 28H15.1361L14.8661 26.29H13.6761L13.3961 28H11.7061L13.2361 19.9ZM14.6961 25.22L14.2661 22.06L13.8361 25.22H14.6961ZM18.1039 19.9H20.3339C21.2206 19.9 21.8906 20.0567 22.3439 20.37C22.7972 20.6833 23.0239 21.24 23.0239 22.04C23.0239 22.58 22.9539 23.01 22.8139 23.33C22.6739 23.65 22.4139 23.9 22.0339 24.08L23.1439 28H21.2939L20.4039 24.37H19.8939V28H18.1039V19.9ZM20.3939 23.34C20.7539 23.34 21.0039 23.2467 21.1439 23.06C21.2906 22.8667 21.3639 22.58 21.3639 22.2C21.3639 21.8333 21.2972 21.56 21.1639 21.38C21.0306 21.1933 20.8006 21.1 20.4739 21.1H19.8939V23.34H20.3939Z",
    fill: "#E37021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRar);
export default __webpack_public_path__ + "static/media/rar.c183b76892681374f69dce8bf7ee9925.svg";
export { ForwardRef as ReactComponent };